// Comprehensive list of Victorian suburbs (Melbourne and surrounding areas)
// Based on Wikipedia Category:Suburbs of Melbourne
export const victorianSuburbs = [
  // A
  "Abbotsford",
  "Aberfeldie", 
  "Aintree",
  "Airport West",
  "Albanvale",
  "Albert Park",
  "Albion",
  "Alphington",
  "Altona",
  "Altona Meadows",
  "Altona North",
  "Ardeer",
  "Armadale",
  "Ascot Vale",
  "Ashburton",
  "Ashwood",
  "Aspendale",
  "Aspendale Gardens",
  "Attwood",
  "Avondale Heights",
  
  // B
  "Balaclava",
  "Balwyn",
  "Balwyn North",
  "Bayswater",
  "Bayswater North",
  "Beaconsfield",
  "Beaumaris",
  "Belgrave",
  "Belgrave Heights",
  "Belgrave South",
  "Bellfield",
  "Bentleigh",
  "Bentleigh East",
  "Berwick",
  "Bittern",
  "Black Rock",
  "Blackburn",
  "Blackburn North",
  "Blackburn South",
  "Blairgowrie",
  "Bonbeach",
  "Bonnie Brook",
  "Boronia",
  "Botanic Ridge",
  "Box Hill",
  "Box Hill North",
  "Box Hill South",
  "Braeside",
  "Braybrook",
  "Briar Hill",
  "Brighton",
  "Brighton East",
  "Broadmeadows",
  "Brookfield",
  "Brooklyn",
  "Brunswick",
  "Brunswick East",
  "Brunswick West",
  "Bulleen",
  "Bundoora",
  "Burnley",
  "Burnside",
  "Burnside Heights",
  "Burwood",
  "Burwood East",
  
  // C
  "Cairnlea",
  "Calder Park",
  "Camberwell",
  "Campbellfield",
  "Canterbury",
  "Capel Sound",
  "Carlton",
  "Carlton North",
  "Carnegie",
  "Caroline Springs",
  "Carrum",
  "Carrum Downs",
  "Caulfield",
  "Caulfield East",
  "Caulfield North",
  "Caulfield South",
  "Chadstone",
  "Chelsea",
  "Chelsea Heights",
  "Cheltenham",
  "Chirnside Park",
  "Clarinda",
  "Clayton",
  "Clayton South",
  "Clifton Hill",
  "Clyde",
  "Clyde North",
  "Cobblebank",
  "Coburg",
  "Coburg North",
  "Collingwood",
  "Coolaroo",
  "Craigieburn",
  "Cranbourne",
  "Cranbourne East",
  "Cranbourne North",
  "Cranbourne West",
  "Cremorne",
  "Crib Point",
  "Croydon",
  "Croydon Hills",
  "Croydon North",
  "Croydon South",
  
  // D
  "Dallas",
  "Dandenong",
  "Dandenong North",
  "Dandenong South",
  "Deanside",
  "Deepdene",
  "Deer Park",
  "Delahey",
  "Derrimut",
  "Diamond Creek",
  "Dingley Village",
  "Docklands",
  "Doncaster",
  "Doncaster East",
  "Donvale",
  "Doreen",
  "Doveton",
  "Dromana",
  
  // E
  "Eaglemont",
  "East Melbourne",
  "Edithvale",
  "Elsternwick",
  "Eltham",
  "Eltham North",
  "Elwood",
  "Emerald",
  "Endeavour Hills",
  "Epping",
  "Essendon",
  "Essendon Fields",
  "Essendon North",
  "Essendon West",
  "Eumemmerring",
  
  // F
  "Fairfield",
  "Fawkner",
  "Ferntree Gully",
  "Ferny Creek",
  "Fieldstone",
  "Fitzroy",
  "Fitzroy North",
  "Flemington",
  "Footscray",
  "Forest Hill",
  "Frankston",
  "Frankston North",
  "Frankston South",
  "Fraser Rise",
  
  // G
  "Garden City",
  "Gardenvale",
  "Gladstone Park",
  "Glen Huntly",
  "Glen Iris",
  "Glen Waverley",
  "Glenroy",
  "Gowanbrae",
  "Grangefields",
  "Greensborough",
  "Greenvale",
  
  // H
  "Hadfield",
  "Hallam",
  "Hampton",
  "Hampton East",
  "Hampton Park",
  "Harkaway",
  "Harkness",
  "Hastings",
  "Hawthorn",
  "Hawthorn East",
  "Heatherton",
  "Heathmont",
  "Heidelberg",
  "Heidelberg Heights",
  "Heidelberg West",
  "Highett",
  "Hillside",
  "Hoppers Crossing",
  "Hughesdale",
  "Huntingdale",
  
  // I
  "Ivanhoe",
  "Ivanhoe East",
  
  // J
  "Jacana",
  "Junction Village",
  
  // K
  "Kalorama",
  "Kealba",
  "Keilor Downs",
  "Keilor East",
  "Keilor Lodge",
  "Keilor North",
  "Keilor Park",
  
  // L
  "Lalor",
  "Langwarrin",
  "Laverton",
  "Lilydale",
  "Lower Plenty",
  
  // M
  "Macleod",
  "Malvern",
  "Malvern East",
  "Maribyrnong",
  "Meadow Heights",
  "Melbourne",
  "Melton",
  "Melton South",
  "Melton West",
  "Mentone",
  "Mickleham",
  "Middle Park",
  "Mill Park",
  "Mitcham",
  "Monbulk",
  "Mont Albert",
  "Montmorency",
  "Moorabbin",
  "Mooroolbark",
  "Mordialloc",
  "Mornington",
  "Mount Evelyn",
  "Mount Waverley",
  
  // N
  "Narre Warren",
  "Narre Warren North",
  "Narre Warren South",
  "Newport",
  "Noble Park",
  "Noble Park North",
  "North Melbourne",
  "Northcote",
  "Notting Hill",
  "Nunawading",
  
  // O
  "Oakleigh",
  "Oakleigh East",
  "Oakleigh South",
  "Officer",
  "Olinda",
  "Ormond",
  
  // P
  "Pakenham",
  "Pakenham Upper",
  "Parkdale",
  "Parkville",
  "Pascoe Vale",
  "Pascoe Vale South",
  "Point Cook",
  "Port Melbourne",
  "Prahran",
  "Preston",
  "Preston South",
  
  // R
  "Reservoir",
  "Richmond",
  "Ringwood",
  "Ringwood East",
  "Ringwood North",
  "Ripponlea",
  "Rosebud",
  "Roxburgh Park",
  
  // S
  "Sandringham",
  "Scoresby",
  "Seaford",
  "Selby",
  "South Melbourne",
  "Southbank",
  "South Yarra",
  "Spotswood",
  "Springvale",
  "St Albans",
  "St Kilda",
  "St Kilda East",
  "St Kilda West",
  "Sunbury",
  "Sunshine",
  "Sunshine North",
  "Sunshine West",
  "Surrey Hills",
  "Sydenham",
  
  // T
  "Templestowe",
  "Templestowe Lower",
  "Thomastown",
  "Thornbury",
  "Toorak",
  "Truganina",
  
  // V
  "Vermont",
  "Vermont South",
  
  // W
  "Wantirna",
  "Wantirna South",
  "Warrandyte",
  "Warranwood",
  "Waterways",
  "Watsonia",
  "Wattle Glen",
  "Werribee",
  "Werribee South",
  "West Footscray",
  "West Melbourne",
  "Wheelers Hill",
  "Williamstown",
  "Williamstown North",
  "Windsor",
  "Wollert",
  "Wyndham Vale",
  
  // Y
  "Yarra Glen",
  "Yarraville"
];

// Sort suburbs alphabetically for better user experience
export const sortedVictorianSuburbs = [...victorianSuburbs].sort();
